import { Injectable } from '@angular/core';
import { ApiService } from '../../shared';
import { ReportInfoDto } from './dto/report-info.dto';
import { FileService } from '../../shared/file/file.service';
import { ReportMenuDto } from 'src/app/config/shared/dto/report-menu.dto';

@Injectable({
  providedIn: 'root',
})
export class ReportFileService {
  constructor(private _apiService: ApiService, private _fileService: FileService) {}
  //get custom report names
  public getCustomReportNames(): Promise<Array<ReportInfoDto>> {
    return this._apiService.get('report/custom/names');
  }
  public getCustomReportDashboardMenu(): Promise<ReportMenuDto> {
    return this._apiService.get('report/custom/dashboardmenu');
  }
  //save reports
  public downloadStandardReport(reportName: string): void {
    const fileUrl = 'report/standard/file/' + reportName;
    this._fileService.downloadFile(fileUrl, reportName);
  }

  public downloadCustomReport(reportName: string): void {
    const fileUrl = 'report/custom/file/' + reportName;
    this._fileService.downloadFile(fileUrl, reportName);
  }
  //download reports
  public uploadStandardReport(formData: FormData): void {
    const fileUrl = 'report/standard/file';
    this._fileService.uploadFile(fileUrl, formData);
  }

  public uploadCustomReport(formData: FormData): void {
    const fileUrl = 'report/custom/file';
    this._fileService.uploadFile(fileUrl, formData);
  }
}
